import React from 'react';
import { EyeIcon, GraduationCapIcon, LayoutListIcon, PrinterIcon, WrenchIcon } from 'lucide-react';
import { differentiators } from '../data/content';
const ICONS = [WrenchIcon, EyeIcon, LayoutListIcon, PrinterIcon, GraduationCapIcon];
export function NotAnEbook() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-14" data-id="element-124" data-mp="3qhkn0o1erobh">
      <div className="mx-auto max-w-[940px] text-center" data-id="element-125" data-mp="3qfgflw4aw76g">
        <h2 className="text-balance text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[1.9rem]" data-id="element-126" data-mp="3mgh41so2dc61">
          This Is NOT Another Health Education Ebook
        </h2>
        <p className="mt-2 text-[1.25rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.6rem]" data-id="element-127" data-mp="3cikydgdwb9fb">
          It’s a Complete Ready-to-Teach System
        </p>

        <dl className="mx-auto mt-7 grid max-w-[640px] gap-x-6 gap-y-3 text-left sm:grid-cols-2" data-id="element-128" data-mp="1ap3pk9e142iz">
          {differentiators.map((item, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <div key={item.title} className="flex items-start gap-3" data-id="element-129" data-mp="3n25pti4ppda1" data-mpi={index}>
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" data-id="element-130" data-mp="3s3la37z2ffrd" />
                <div data-id="element-131" data-mp="3d7nje57wv3mj">
                  <dt className="text-[0.95rem] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-132" data-mp="3i4456srn15wg">
                    {item.title}
                  </dt>
                  <dd className="mt-0.5 text-[0.9rem] leading-snug text-white/80" data-id="element-133" data-mp="9qnf7fh4rd42">
                    {item.description}
                  </dd>
                </div>
              </div>;
        })}
        </dl>

        <p className="mt-7 text-balance text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.15rem]" data-id="element-134" data-mp="4xkmf9k6g7ox">
          Less searching. More lessons already solved.
        </p>
      </div>
    </section>;
}